import { LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'
import MarketValueAnalysis from './MarketValueAnalysis'
import { SelectableAssetList } from './components/SelectableAssetList/SelectableAssetList'
import { useAnalysisData } from './Analysis.data'
import { Headline } from 'ComponentLibrary/src/piazza/text/Headline/Headline'
import { Box, Divider, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

const ANALYSIS_COLUMN_BASIS = '560px'

export function AnalysisPage() {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { assets, summary, filteredSummary, history, normalizedHistory, isMultiAssetValueOverviewDataPending, isFilteredSummaryPending } =
        useAnalysisData()

    if (isMultiAssetValueOverviewDataPending) {
        return (
            <PageGridContainer withTopSpace withBottomSpace withFooter>
                <PageGridItem columnSpan={6} columnSpanXs={4}>
                    <Headline title={tCommon('analysis')} variant="headline1" />
                </PageGridItem>
                <PageGridItem columnSpan={6} columnSpanXs={4}>
                    <Stack direction="row" gap={tokens.SizingSpacing500} flexWrap="wrap-reverse">
                        <Box flex={`1 1 ${ANALYSIS_COLUMN_BASIS}`} minWidth={0}>
                            <Stack direction="column" width="100%" gap={tokens.SizingSpacing150}>
                                <LoadingSkeleton height="90px" variant="rounded" />
                                <Divider />
                                <LoadingSkeleton count={4} height="90px" variant="rounded" />
                            </Stack>
                        </Box>
                        <Box flex={`1 1 ${ANALYSIS_COLUMN_BASIS}`} minWidth={0}>
                            <Stack direction="column" width="100%" gap={tokens.SizingSpacing300}>
                                <LoadingSkeleton height="108px" variant="rounded" />
                                <LoadingSkeleton height="390px" variant="rounded" />
                            </Stack>
                        </Box>
                    </Stack>
                </PageGridItem>
            </PageGridContainer>
        )
    }

    return (
        <PageGridContainer withTopSpace withBottomSpace withFooter>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <Headline title={tCommon('analysis')} variant="headline1" />
            </PageGridItem>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <Stack direction="row" gap={tokens.SizingSpacing500} flexWrap="wrap-reverse">
                    <Box flex={`1 1 ${ANALYSIS_COLUMN_BASIS}`} minWidth={0} paddingTop={tokens.SizingSpacing100}>
                        <SelectableAssetList assets={assets} isPending={isMultiAssetValueOverviewDataPending} summary={summary} />
                    </Box>
                    <Box flex={`1 1 ${ANALYSIS_COLUMN_BASIS}`} minWidth={0}>
                        <MarketValueAnalysis
                            summary={filteredSummary}
                            assets={assets}
                            isFilteredSummaryPending={isFilteredSummaryPending}
                            history={history}
                            normalizedHistory={normalizedHistory}
                        />
                    </Box>
                </Stack>
            </PageGridItem>
        </PageGridContainer>
    )
}
